import masterData from '../masterData';

export const conditionString = (value, pref) => {
  // console.log(value, pref);
  const parts = [];
  if (value && value.condition) {
    const condition = value.condition;
    // キーワード
    if (condition.keyword) {
      if(condition.keyword.startsWith('geo')){
        parts.push("現在地から検索");
      } else{
        let prefix = '';
        if (condition.keywordTarget) {
          if (condition.keywordTarget == 1) {
            prefix = '住所：';
          }
          else if (condition.keywordTarget == 2) {
            prefix = '駅名：';
          }
          else if (condition.keywordTarget == 3) {
            prefix = '物件名：';
          }
        }
        parts.push(prefix+condition.keyword);
      }
    }
  }
  if (pref) {
    parts.push(masterData.pref.byId[pref].name);
  }
  if (value && value.condition) {
    const condition = value.condition;
    // 地域
    if (condition.city) {
      parts.push(
        condition.city.map(city => masterData.city.byPrefAndSlug[pref][city].name).join("・")
      );
    }
    // 路線
    if (condition.line){
      parts.push(
        condition.line.map((l) => {
          return masterData.line.bySlug[l].name
        })
        .join("・")
      );
    }
    // 駅
    if (condition.station){
      parts.push(
        condition.station.map((stationId) => {
          return masterData.station.byId[stationId] && masterData.station.byId[stationId].name
        })
        .join("・")
      );
    }
    // 空き予定
    if (!condition.targetState || condition.targetState == 0) {
      parts.push('空室物件から検索');
    }
    else if (condition.targetState == 1) {
      parts.push('空き予定を含む');
    }
    else if (condition.targetState == 2) {
      parts.push('全部屋から検索');
    }
    // キャンペーン中物件から選ぶ
    if (condition.campaign) {
      parts.push('キャンペーン物件から選ぶ');
    }
    // タイプ
    if (condition.assetType && condition.assetType.length) {
      if(Object.prototype.toString.call(condition.assetType) === '[object Array]'){
        let _assetTypes = [];
        parts.push(condition.assetType.map((atype) => {
          return masterData.assetType.bySlug[atype].name;
        }).join('・'));
      }else{
        parts.push(masterData.assetType.bySlug[condition.assetType].name);        
      }
    }
    // 金額
    if (condition.priceFrom && condition.priceTo) {
      parts.push('金額'+parseInt(condition.priceFrom).toLocaleString()+'円～'+parseInt(condition.priceTo).toLocaleString()+'円');
    }
    else if (condition.priceFrom) {
      parts.push('金額'+parseInt(condition.priceFrom).toLocaleString()+'円～');
    }
    else if (condition.priceTo) {
      parts.push('金額～'+parseInt(condition.priceTo).toLocaleString()+'円');
    }
    // 広さ
    if (condition.extentFrom && condition.extentTo) {
      parts.push('広さ'+condition.extentFrom+'帖～'+condition.extentTo+'帖');
    }
    else if (condition.extentFrom) {
      parts.push('広さ'+condition.extentFrom+'帖～');
    }
    else if (condition.extentTo) {
      parts.push('広さ～'+condition.extentTo+'帖');
    }
    // 階数
    if (condition.floor && condition.floor == '1') {
      parts.push('1階のみ');
    }
    if (condition.floor && condition.floor == '2') {
      parts.push('1階以外');
    }
    // 設備
    if (condition.facility && condition.facility.length) {
      if (condition.facility.indexOf("parking") != -1) {
        parts.push('駐車場有');
      }
      if (condition.facility.indexOf("elevator") != -1) {
        parts.push('エレベーター有');
      }
      if (condition.facility.indexOf("aircon") != -1) {
        parts.push('空調有');
      }
      if (condition.facility.indexOf("access") != -1) {
        parts.push('駅近物件');
      }
    }

    // 金額（旧）
    if (condition.price) {
      parts.push(masterData.price.byValue[condition.price].name);
    }
    // 広さ（旧）
    if (condition.extent) {
      parts.push(masterData.extent.byValue[condition.extent].name);
    }
    // 満室物件を含む（旧）
    if (condition.manshitsu) {
      parts.push('満室物件を含む');
    }
  }
  return parts.join("、");
};

conditionString.injects = ['city', 'pref']



// WEBPACK FOOTER //
// ./lib/masterUtil/conditionString.js